var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilledHeart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_12_2736)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.0001 21.2999C11.8685 21.3007 11.738 21.2755 11.6162 21.2257C11.4944 21.176 11.3836 21.1026 11.2901 21.0099L3.52012 13.2299C2.54548 12.2451 1.99878 10.9155 1.99878 9.52994C1.99878 8.14438 2.54548 6.81477 3.52012 5.82994C4.50238 4.85045 5.83295 4.30042 7.22012 4.30042C8.60729 4.30042 9.93785 4.85045 10.9201 5.82994L12.0001 6.90994L13.0801 5.82994C14.0624 4.85045 15.3929 4.30042 16.7801 4.30042C18.1673 4.30042 19.4979 4.85045 20.4801 5.82994C21.4548 6.81477 22.0015 8.14438 22.0015 9.52994C22.0015 10.9155 21.4548 12.2451 20.4801 13.2299L12.7101 21.0099C12.6167 21.1026 12.5059 21.176 12.384 21.2257C12.2622 21.2755 12.1317 21.3007 12.0001 21.2999Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_12_2736"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0 0.299927)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilledHeart);
export default __webpack_public_path__ + "static/media/filled-heart.d14e7c1e2ecf6aeda2a6f0ec4193d137.svg";
export { ForwardRef as ReactComponent };